import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NzCarouselComponent } from "ng-zorro-antd";
import { BreakpointObserver } from '@angular/cdk/layout';
import {ProductShort} from "../../../common/common-product/models/product-short.model";
import {AddLineItemToShoppingCart} from "../../../shopping-cart/actions/shopping-cart.actions";

@Component({
  selector: 'leap-related-products-carousel',
  templateUrl: './related-products-carousel.component.html',
  styleUrls: ['./related-products-carousel.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RelatedProductsCarouselComponent implements OnInit {

  @Input() title : String;
  @Input() caption : String;
  @Input() products : Array<ProductShort>;

  @Input() addLineItemSku: string;
  @Input() addLineItemPending: boolean;

  @Input() currencySignsMap: Map<string, string>;

  @Input() isLogged: boolean;

  @Output() goToDetails: EventEmitter<any> = new EventEmitter();
  @Output() addToCart: EventEmitter<string> = new EventEmitter();
  @Output() seeMoreClick : EventEmitter<ProductShort> = new EventEmitter();

  @ViewChild('carouselComponent', { static: true }) carouselComponent : NzCarouselComponent;

  isSmScreen;
  isMdScreen;
  isLgScreen;
  isXlScreen;

  smArray = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
  smItems = [0];

  mdArray = [0, 1, 2, 3, 4, 5]; 
  mdItems = [0, 1];

  lgArray = [0, 1, 2, 3];
  lgItems = [0, 1, 2];

  xlArray = [0, 1, 2];
  xlItems = [0, 1, 2, 3];

  effect = 'scrollx';

  constructor(private breakpointObserver: BreakpointObserver) { }

  ngOnInit() {
    this.isSmScreen = this.breakpointObserver.isMatched(['(max-width: 768px)']);
    this.isMdScreen = this.breakpointObserver.isMatched(['(min-width: 769px) and (max-width: 992px)']);
    this.isLgScreen = this.breakpointObserver.isMatched(['(min-width: 993px) and (max-width: 1200px)']);
    this.isXlScreen = this.breakpointObserver.isMatched('(min-width: 1201px)');
  }

  patchCarouselPages(carouselItems) {
    if (!this.products || !this.products.length) return;
    let expectedPageLength = Math.ceil((this.products.length / carouselItems.length));
    let pages = [];
    pages.length = expectedPageLength;
    return pages;
  }

  isSeeMoreAvailable() {
    return this.seeMoreClick.observers.length > 0;
  }

  goToRelatedProductDetails(selectedVariant: any) {
    this.goToDetails.emit(selectedVariant);
  }

  addRelatedProductToCart(sku: string) {
    this.addToCart.emit(sku);
  }

  seeMoreClickFn() {
    this.seeMoreClick.emit();
  }
}
